import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="flex min-h-screen items-center justify-center bg-cream px-6 text-forest">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: EASE }}
        className="w-full max-w-lg border border-forest/15 p-10 text-center md:p-14"
      >
        <h1 className="font-serif text-4xl italic md:text-5xl" data-testid="payment-cancel-heading">
          No worries — your basket is safe.
        </h1>
        <p className="mt-4 text-sm leading-relaxed text-sage">
          The payment was cancelled and no money was taken. Your flowers are
          still waiting whenever you are ready.
        </p>
        <Link
          to="/shop"
          data-testid="payment-cancel-back-link"
          className="mt-10 inline-flex items-center gap-3 rounded-full bg-forest px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-cream transition-colors duration-300 hover:bg-marigold hover:text-forest"
        >
          <ArrowLeft size={16} />
          Back to the Collection
        </Link>
      </motion.div>
    </main>
  );
}
